import { GridTemplateValue } from '@billy/design-system'

export const DEMO_INVOICE_LINE_COLUMNS_TEMPLATE: GridTemplateValue[] = [8, '74px', 4, 4, 5, 4, 5]

export const DEMO_INVOICE_LINE_COLUMNS_TEMPLATE_WITH_DISCOUNT: GridTemplateValue[] = [8, '74px', 4, 4, 5, 8, 4, 5]
